"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TabLink = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Icon = require("../Icon");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var buttonStyles = function buttonStyles(tabActive, theme) {
  var themeSmallBlue = theme === 'small-blue';
  return (0, _classnames.default)('border-none bg-transparent cursor-pointer self-center block m-auto', {
    'tw-label-medium text-blue1-60': themeSmallBlue && tabActive
  }, {
    'tw-label-medium text-grey-60': themeSmallBlue && !tabActive
  }, {
    'tw-label-medium text-green1-55': !themeSmallBlue && tabActive
  }, {
    'tw-label-regular text-black': !themeSmallBlue && !tabActive
  });
};
var activeUnderlineStyles = function activeUnderlineStyles(theme) {
  var themeSmallBlue = theme === 'small-blue';
  return (0, _classnames.default)('box-border rounded-t-[6px] w-full block', {
    'bg-blue1-50 h-[2px] mt-[6px]': themeSmallBlue
  }, {
    'bg-green1-55 h-[4px] mt-[14px]': !themeSmallBlue
  });
};
var TabLink = function TabLink(_ref) {
  var tab = _ref.tab,
    theme = _ref.theme,
    tabLabelStyles = _ref.tabLabelStyles,
    id = _ref.id,
    showDot = _ref.showDot,
    onChange = _ref.onChange;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "--tag-tab-link inline-block relative",
    id: id
  }, /*#__PURE__*/_react.default.createElement("button", {
    className: (0, _classnames.default)('--tag-tab-link-label px-[16px]', buttonStyles(tab.active, theme), tabLabelStyles),
    onClick: onChange
  }, tab.label), tab.active && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(activeUnderlineStyles(theme))
  }), showDot && /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    className: "absolute top-0 left-[2px]",
    type: "green-dot",
    size: 8
  }));
};
exports.TabLink = TabLink;